/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoggedInUser } from '../models/LoggedInUser';
import type { UserDetails } from '../models/UserDetails';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoggedInUserService {
    /**
     * Get logged in user
     * @returns LoggedInUser successful
     * @throws ApiError
     */
    public static getLoggedInUser(): CancelablePromise<LoggedInUser> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user.json',
        });
    }
    /**
     * Get logged in user without authorization
     * @returns LoggedInUser successful
     * @throws ApiError
     */
    public static getLoggedInUserWithoutAuthorization(): CancelablePromise<LoggedInUser> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/without_authorization.json',
        });
    }
    /**
     * Get logged in user details
     * @returns UserDetails successful
     * @throws ApiError
     */
    public static getLoggedInUserDetails(): CancelablePromise<UserDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/details.json',
        });
    }
}
